import { useTranslation } from 'react-i18next';
import { ButtonPropsWithLabel } from 'src/components/Dialog';

import { BlockingReasonRow } from './BlockingReasonRow';
import { BlockingReasonVariant } from './_types';
import { blockingReasonTranslationKey } from './blockingReasonTranslationKey';

// LEGACY: superseded by `RequiredDocumentReason`, which renders the live
// required-documents block for the `waiver_required` blocker type. This
// component is kept only as the placeholder/mock UI for the legacy camelCase
// `waiverRequired` blocker type. Do not use for new work; prefer
// `RequiredDocumentReason`.
// Mock: waiver blocking reason UI is a placeholder for future implementation.
// Once the waiver API exists, this component will fetch real data.
export function WaiverRequiredReason({
  _userId,
  actions,
  inlineActions = false,
  variant = 'checkin',
}: {
  _userId: string;
  actions?: ButtonPropsWithLabel[];
  inlineActions?: boolean;
  variant?: BlockingReasonVariant;
}) {
  const { t } = useTranslation('translation', { keyPrefix: 'checkinBlocker' });

  const fallbackActions = [
    {
      label: t('actions.viewDocument'),
      variant: 'bordered',
    },
    {
      label: t('actions.override'),
      variant: 'text',
    },
  ] as ButtonPropsWithLabel[];

  return (
    <BlockingReasonRow
      title={t(blockingReasonTranslationKey(variant, 'waiverRequired', 'title'))}
      message={t(
        blockingReasonTranslationKey(variant, 'waiverRequired', 'message')
      )}
      actions={actions ?? (inlineActions ? fallbackActions : undefined)}
    />
  );
}
